import React, { useState } from 'react';
import { Play, X, ChevronLeft, ChevronRight } from 'lucide-react';

const DemoVideos = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentVideo, setCurrentVideo] = useState(0);

  const videos = [
    {
      id: 1,
      title: "Casa Bella Restaurant Assistant",
      description: "AI handling restaurant orders and reservations",
      videoSrc: "/chatbot-landing .mp4",
      isLocal: true
    },
    {
      id: 2,
      title: "Mavic 3 Pro Support Agent",
      description: "AI providing technical support for Mavic 3 Pro",
      videoSrc: "/support-agent.mp4",
      isLocal: true
    }
  ];

  const openModal = (index) => {
    setCurrentVideo(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const nextVideo = () => {
    setCurrentVideo((prev) => (prev + 1) % videos.length);
  };

  const prevVideo = () => {
    setCurrentVideo((prev) => (prev - 1 + videos.length) % videos.length);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') closeModal();
    if (e.key === 'ArrowRight') nextVideo();
    if (e.key === 'ArrowLeft') prevVideo();
  };

  React.useEffect(() => {
    if (isModalOpen) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [isModalOpen]);

  return (
    <section className="section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">See it in action</h2>
          <p className="section-subtitle">
            Watch real demonstrations of AI assistants helping businesses like yours.
          </p>
        </div>
        <div className="demo-grid">
          {videos.map((video, index) => (
            <div key={video.id} className="demo-placeholder">
              <div 
                className="demo-video-placeholder"
                onClick={() => openModal(index)}
              >
                <div className="video-preview">
                  <div className="play-button">
                    <Play size={32} />
                  </div>
                </div>
                <div className="video-info">
                  <h4>{video.title}</h4>
                  <p>{video.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Video Modal */}
      {isModalOpen && (
        <div className="video-modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <button className="close-button" onClick={closeModal}>
                <X size={20} />
              </button>
            </div>
            
            <div className="video-container">
              <video
                width="100%"
                height="100%"
                controls
                autoPlay
                src={videos[currentVideo].videoSrc}
                title={videos[currentVideo].title}
              >
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default DemoVideos;